<template>
	<div class="row" v-if="clubMemberPolicies">
		<div class="panel" :class="this.panelClass">
			<!-- Default panel contents -->
			<div class="panel-heading"><h3 class="panel-title">Club Policies</h3></div>
			<div class="panel-body" v-if="this.pending_only">
				<p>The Club Policies shown below are currently awaiting confirmation of acceptance by the relevant Club Member. By accepting the policies shown below, you are confirming that you are acting on behalf of the relevant members and that the members understand the relevant policy and agree to adhere to the policy.</p>
			</div>
			<table class="table table-striped">
				<thead>
					<tr>
						<th>Member</th>
						<th>Applicable Policy</th>
						<th>&nbsp;</th>
						<th>&nbsp;</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(clubPolicy, index) in clubMemberPolicies" v-on:click="">
						<td style="vertical-align: middle">{{ clubPolicy.member.name }}</td>
						<td style="vertical-align: middle">{{ clubPolicy.policy.name }}</td>
						<td style="" class="text-right align-middle">
							<button class="btn btn-success btn-sm" v-if="clubPolicy.acceptance_pending" v-on:click="acceptClubMemberPolicy(clubPolicy)">Accept Policy&nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></button>
							<span class="text-success " v-if="!clubPolicy.acceptance_pending">Accepted on {{ new Date(clubPolicy.acceptance_provided_at).toLocaleString('en-GB') }} by {{ clubPolicy.accepted_by_member.name }}</span>
						</td>
						<td class="row-actions"><a :href="clubPolicy.policy.url" class="btn btn-primary btn-sm">Download Policy&nbsp;<span class="glyphicon glyphicon-save" aria-hidden="true"></span></a></td>
							
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>

import { DatePicker, Message, Icon, Tooltip, Loading } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);


export default {
	components: { DatePicker, Message, Tooltip, Icon, Loading },
	props: {
		account_id: Number,
		pending_only: Boolean,
		type: {
			type: String,
			default: 'primary'
		}
	},
	data: function () {
		return {
			accountId: this.account_id,
			clubMemberPolicies: null,
		}
	},
	computed: {
		queryString() {
			return this.pending_only ? '?filters=acceptance_pending:true' : ''
		},
		panelClass() {
			return `panel-${this.type}`
		}
	},
	mounted() {
		console.log('ClubPolicyAcceptance component mounted.');
		this.getPoliciesToAccept();
	},
	methods: {
		getPoliciesToAccept() {
			console.log('getPoliciesToAccept.');
			// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
			axios.get(`/account/api/policies${this.queryString}`).then((response) => {
				console.log(response.data);
				if (response.data.length > 0) {
					this.clubMemberPolicies = response.data;
				}
				else {
					this.clubMemberPolicies = null;
				}
			}).catch((error) => {
				this.handleHTTPError(error);
			});
		},
		acceptClubMemberPolicy(clubPolicy) {
			console.log('acceptClubMemberPolicy.');
			
			axios.put('/account/api/member_club_policy/' + clubPolicy.id + '/accept').then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.$message({message: 'Thank you - your acceptance has been recorded.', type: 'success'});
				// Every time we make a change to the team we need to sync up the teamMembers array
				this.getPoliciesToAccept();

			}).catch((error) => {
				// this.loadingInstance.close();
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem accepting the policy - please try again later.', type: 'error'});
				this.getPoliciesToAccept();
			});

		},
		handleHTTPError(error) {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data); // Error message
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
				console.log(error.config);
		},

	
	}
}

</script>